module.exports = __webpack_public_path__ + "images/icons/size-guide/10x10.svg";